import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { RegistrationComponent } from './View/registration/registration.component';
import { routes } from './ApplicationRoutes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './View/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Registartionservice } from './Service/registration.service';
import { AlertService } from './Service/alert.service';
import { InjectionToken } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ToastrModule } from 'ngx-toastr';

import { PdfViewerModule } from 'ng2-pdf-viewer';
export const BASE_URL = new InjectionToken<string>('BASE_URL');
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent
  
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    RouterModule,
    DatePickerModule ,
    AppRoutingModule,
    PdfViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule
    
  ],
  
  providers: [Registartionservice,AlertService,{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]  
})
export class AppModule { }
